import { bypassAdmin } from 'src/stores/admin'
import { getApiUrl } from 'src/utils/config'
import { getFingerprint } from 'src/utils/fingerprint'
import {
  setIntercomUserJwt,
  unsetIntercomUserJwt,
} from 'src/utils/intercom/storage'
import { getToken, setToken } from 'src/utils/token'
import { setIPCountry } from '../helpers/ip'
import { createClient } from './generated/client'

export const orpcClient = createClient({
  baseUrl: getApiUrl(),
  credentials: 'include',
})

/** Client for public, cacheable endpoints — no credentials or auth headers. */
export const orpcPublicClient = createClient({
  baseUrl: getApiUrl(),
  credentials: 'omit',
})

orpcClient.interceptors.request.use((request, _options) => {
  const token = getToken()
  if (token) {
    request.headers.set('Authorization', `Bearer ${token}`)
  }

  if (bypassAdmin()) {
    request.headers.set('X-Bypass-Admin', '1')
  }

  const browserId = getFingerprint()
  if (browserId) {
    request.headers.set('X-Browser-ID', browserId)
  }

  return request
})

orpcClient.interceptors.response.use((res, request) => {
  if (res.status === 401) {
    // Only wipe when the failing request actually carried a token.
    // Otherwise an unauthenticated request that lands after a sibling
    // login flow has just stored a fresh token would clobber it.
    if (request.headers.get('Authorization')) {
      setToken('')
      unsetIntercomUserJwt()
    }
  } else {
    const token = res.headers.get('token')
    if (token) {
      setToken(token)
    }
  }
  return res
})

orpcClient.interceptors.response.use(res => {
  const intercomUserJwt = res.headers.get('x-intercom-user-jwt')
  if (intercomUserJwt) {
    setIntercomUserJwt(intercomUserJwt)
  }
  const ipCountry = res.headers.get('x-country-code')
  if (ipCountry) {
    setIPCountry(ipCountry)
  }
  return res
})
